<template>
  <div>
    <Row :gutter="10">
      <!-- 统计数据显示区域 -->
      <i-col :md="24" :lg="24" style="margin-bottom: 10px;">
        <Row :gutter="16">
          <i-col :md="6" :lg="6">
            <Card>
              <div class="statistics-item">
                <Icon type="md-people" size="32" color="#2d8cf0" />
                <div class="statistics-content">
                  <div class="statistics-label">累计用户数</div>
                  <div class="statistics-value">{{ statistics.totalUsers || 0 }}</div>
                  <div class="statistics-note">
                    <div class="note-source">数据来源：微信小程序后台</div>
                    <div class="note-date">统计日期：{{ yesterdayDate }}</div>
                  </div>
                </div>
              </div>
            </Card>
          </i-col>
          <i-col :md="6" :lg="6">
            <Card>
              <div class="statistics-item">
                <Icon type="md-person-add" size="32" color="#19be6b" />
                <div class="statistics-content">
                  <div class="statistics-label">注册用户数</div>
                  <div class="statistics-value">{{ statistics.registeredUsers || 0 }}</div>
                  <div class="statistics-note">
                    <div class="note-source">说明：完成平台注册</div>
                    <div class="note-date">统计时间：{{ todayDate }}</div>
                  </div>
                </div>
              </div>
            </Card>
          </i-col>
          <i-col :md="6" :lg="6">
            <Card>
              <div class="statistics-item">
                <Icon type="md-document" size="32" color="#ff9900" />
                <div class="statistics-content">
                  <div class="statistics-label">简历数</div>
                  <div class="statistics-value">{{ statistics.resumeCount || 0 }}</div>
                  <div class="statistics-note">
                    <div class="note-source">说明：小程序注册后添加了个人简历</div>
                    <div class="note-date">统计时间：{{ todayDate }}</div>
                  </div>
                </div>
              </div>
            </Card>
          </i-col>
          <i-col :md="6" :lg="6">
            <Card>
              <div class="statistics-item">
                <Icon type="md-briefcase" size="32" color="#ed4014" />
                <div class="statistics-content">
                  <div class="statistics-label">求职意向数</div>
                  <div class="statistics-value">{{ statistics.intentionCount || 0 }}</div>
                  <div class="statistics-note">
                    <div class="note-source">说明：小程序注册后添加了求职意向</div>
                    <div class="note-date">统计时间：{{ todayDate }}</div>
                  </div>
                </div>
              </div>
            </Card>
          </i-col>
        </Row>
      </i-col>

      <i-col :md="24" :lg="24" style="margin-bottom: 10px;">
        <Card>
          <Alert banner closable>搜索支持全局搜索和高级搜索，多条件搜索时请使用"|"作为条件分隔符</Alert>
          <div class="search-con search-con-top">
               <Row>
            <i-col span="19">
            <Input class="search-input" v-model="searchVal" style="padding:5px;" placeholder="输入关键字全局搜索" @on-enter="searchinput"/>
            <Button v-if="rules.persearch" type="info" @click="showAdvancedSearch = !showAdvancedSearch" class="search-btn">
              {{ showAdvancedSearch ? '收起高级搜索' : '高级搜索' }}
            </Button>
            <slot name="new_btn" v-if="rules.peradd">
              <Button type="primary" @click="editModal('', 'post', '添加求职者')" class="search-btn">添加求职者</Button>
            </slot>
<!--            <Button type="error" class="search-btn" @click="handlerDelete">批量删除</Button>-->
 </i-col>
              <i-col span="3">
                <Upload v-if="rules.perimport"  style="text-align: right; margin-top:5px;" action="" :before-upload="handleBeforeUpload" accept=".xls, .xlsx">

                <Button icon="ios-cloud-upload-outline" :loading="uploadLoading" @click="handleUploadFile">导入</Button>
                </Upload></i-col>
              <i-col><el-link v-if="rules.perimport" href="../../download/求职者导入模板.xlsx" style="margin-left: 10px; height: 100%" type="primary" >模板下载</el-link></i-col>
</Row>
          <Row>
              <div class="ivu-upload-list-file" v-if="file !== null">
                <Icon type="ios-stats"></Icon>
                {{ file.name }}
                <Icon v-show="showRemoveFile" type="ios-close" class="ivu-upload-list-remove"
                      @click.native="handleRemove()"></Icon>
              </div>
            </Row>
            <Row>
              <transition name="fade">
                <Progress v-if="showProgress" :percent="progressPercent" :stroke-width="2">
                  <div v-if="progressPercent == 100">
                    <Icon type="ios-checkmark-circle"></Icon>
                    <span>成功</span>
                  </div>
                </Progress>

              </transition>
              <el-progress :text-inside="true" :stroke-width="24" :percentage="inprogress" v-if="progressPercent == 100" status="success" style="margin-bottom: 10px;margin-top: 10px"></el-progress>
              <Button v-if="progressPercent == 100&&!showre" type="error" class="search-btn" :loading="uploadLoading"
                      @click="handlerimport">确认导入
              </Button>

              <div v-if="showre" class="ivu-upload-list-file">
                {{ showretxt }}
              </div>
            </Row>

            <!-- 高级搜索区域 -->
            <Row v-if="showAdvancedSearch" style="margin-top: 15px;">
              <Card dis-hover>
                <p slot="title">高级搜索</p>
                <Form :model="advancedSearchForm" inline :label-width="80">
                  <Row :gutter="16">
                    <i-col :md="8" :lg="8">
                      <FormItem label="姓名">
                        <Input v-model="advancedSearchForm.Pname" placeholder="请输入姓名"></Input>
                      </FormItem>
                    </i-col>
                    <i-col :md="8" :lg="8">
                      <FormItem label="性别">
                        <el-select v-model="advancedSearchForm.Psex" placeholder="请选择性别" clearable>
                          <el-option v-for="item in PsexList" :key="item.value" :label="item.meaning" :value="item.value"></el-option>
                        </el-select>
                      </FormItem>
                    </i-col>
                    <i-col :md="8" :lg="8">
                      <FormItem label="联系电话">
                        <Input v-model="advancedSearchForm.Pphone" placeholder="请输入联系电话"></Input>
                      </FormItem>
                    </i-col>
                  </Row>
                  <Row :gutter="16">
                    <i-col :md="8" :lg="8">
                      <FormItem label="学历">
                        <el-select v-model="advancedSearchForm.Peducation" placeholder="请选择学历" clearable>
                          <el-option v-for="item in PeducationList" :key="item.value" :label="item.meaning" :value="item.value"></el-option>
                        </el-select>
                      </FormItem>
                    </i-col>
                    <i-col :md="8" :lg="8">
                      <FormItem label="工作经验">
                        <el-select v-model="advancedSearchForm.Pexperience" placeholder="请选择工作经验" clearable>
                          <el-option v-for="item in PexperienceList" :key="item.value" :label="item.meaning" :value="item.value"></el-option>
                        </el-select>
                      </FormItem>
                    </i-col>
                    <i-col :md="8" :lg="8">
                      <FormItem label="期望薪资">
                        <el-select v-model="advancedSearchForm.Psalary" placeholder="请选择期望薪资" clearable>
                          <el-option v-for="item in PsalaryList" :key="item.value" :label="item.meaning" :value="item.value"></el-option>
                        </el-select>
                      </FormItem>
                    </i-col>
                  </Row>
                  <Row :gutter="16">
                    <i-col :md="8" :lg="8">
                      <FormItem label="现居住地">
                        <Input v-model="advancedSearchForm.Pnowaddress" placeholder="请输入现居住地"></Input>
                      </FormItem>
                    </i-col>
                    <i-col :md="8" :lg="8">
                      <FormItem label="期望职位">
                        <Input v-model="advancedSearchForm.Pjob" placeholder="请输入期望职位"></Input>
                      </FormItem>
                    </i-col>
                    <i-col :md="8" :lg="8">
                      <FormItem label="状态">
                        <el-select v-model="advancedSearchForm.Pstate" placeholder="请选择状态" clearable>
                          <el-option label="待审核" value="0"></el-option>
                          <el-option label="已通过" value="1"></el-option>
                          <el-option label="已拒绝" value="2"></el-option>
                        </el-select>
                      </FormItem>
                    </i-col>
                  </Row>
                  <Row>
                    <i-col :md="24" :lg="24" style="text-align: right;">
                      <Button type="primary" @click="advancedSearch">搜索</Button>
                      <Button @click="resetAdvancedSearch" style="margin-left: 8px;">重置</Button>
                    </i-col>
                  </Row>
                </Form>
              </Card>
            </Row>
          </div>
          <Spin size="large" fix v-if="spinShow"></Spin>

          <Table v-loading.fullscreen.lock="fullscreenLoading" height="470" size="small" ref="selection" border :columns="columns" :data="tableData"
                 @on-selection-change="handleSelectChange"></Table>
          <div style="margin: 10px; overflow: hidden">
            <div style="float: left;">
              <Page :total="pageTotal" :current="pageNum" :page-size="pageSize" :page-size-opts=[15,35,50,100]
                    show-sizer show-total @on-change="changePage" @on-page-size-change="handlePageSize">
              </Page>
            </div>
          </div>
          <Modal v-model="modalMap.modalVisible" :title="modalMap.modalTitle" :loading=true :footer-hide=true
                 :mask-closable=false>
            <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="100">

              <FormItem
                label="姓名"
                prop="Pname"
              >
                <Input
                  v-model="formValidate.Pname"
                  placeholder="请输入姓名"
                  disabled
                  v-if="formValidate.Id != 0"
                ></Input>
                <Input
                  v-model="formValidate.Pname"
                  placeholder="请输入姓名"
                  v-if="formValidate.Id == 0"
                ></Input>
              </FormItem>
              <FormItem label="性别" prop="Psex">
                <el-select
                  v-model="formValidate.Psex"
                  filterable
                  allow-create
                  default-first-option
                  placeholder="请选择，如果没有合适的类型可以自己创建">
                  <el-option
                    v-for="item in PsexList"
                    :key="item.value"
                    :label="item.meaning"
                    :value="item.value">
                  </el-option>
                </el-select>

              </FormItem>

              <FormItem
                label="身份证"
                prop="Pidcard"
              >
                <Input
                  v-model="formValidate.Pidcard"
                  placeholder="请输入"
                ></Input>
              </FormItem>
              <FormItem label="户籍地址" prop="Paddress">
                <Input
                  v-model="formValidate.Paddress"
                  placeholder="请输入"
                ></Input>
              </FormItem>
              <FormItem label="现居住区域" prop="Pnowaddress">
                <Input
                  v-model="formValidate.Pnowaddress"
                  placeholder="请输入"
                ></Input>
              </FormItem>
              <FormItem label="联系电话" prop="Pphone">
                <Input
                  v-model="formValidate.Pphone"
                  placeholder="请输入"
                ></Input>
              </FormItem>
              <FormItem label="婚姻状况" prop="Pmarriage">
                <el-select
                  v-model="formValidate.Pmarriage"
                  filterable
                  allow-create
                  default-first-option
                  placeholder="请选择，如果没有合适的类型可以自己创建">
                  <el-option
                    v-for="item in PmarriageList"
                    :key="item.value"
                    :label="item.meaning"
                    :value="item.value">
                  </el-option>
                </el-select>

              </FormItem>

              <FormItem label="民族" prop="Pnation">
                <el-select
                  v-model="formValidate.Pnation"
                  filterable
                  allow-create
                  default-first-option
                  placeholder="请选择，如果没有合适的类型可以自己创建">
                  <el-option
                    v-for="item in PnationList"
                    :key="item.value"
                    :label="item.meaning"
                    :value="item.value">
                  </el-option>
                </el-select>

              </FormItem>
              <FormItem label="学历" prop="Peducation">
                <el-select
                  v-model="formValidate.Peducation"
                  filterable
                  allow-create
                  default-first-option
                  placeholder="请选择，如果没有合适的类型可以自己创建">
                  <el-option
                    v-for="item in PeducationList"
                    :key="item.value"
                    :label="item.meaning"
                    :value="item.value">
                  </el-option>
                </el-select>
              </FormItem>
              <FormItem label="工作经验" prop="Pexperience">
                <el-select
                  v-model="formValidate.Pexperience"
                  filterable
                  allow-create
                  default-first-option
                  placeholder="请选择，如果没有合适的类型可以自己创建">
                  <el-option
                    v-for="item in PexperienceList"
                    :key="item.value"
                    :label="item.meaning"
                    :value="item.value">
                  </el-option>
                </el-select>
              </FormItem>
              <FormItem label="期望薪资" prop="Psalary">
                <el-select
                  v-model="formValidate.Psalary"
                  filterable
                  allow-create
                  default-first-option
                  placeholder="请选择，如果没有合适的类型可以自己创建">
                  <el-option
                    v-for="item in PsalaryList"
                    :key="item.value"
                    :label="item.meaning"
                    :value="item.value">
                  </el-option>
                </el-select>
              </FormItem>

              <FormItem label="期望职位" prop="Pjob">
                <Input
                  v-model="formValidate.Pjob"
                  placeholder="请输入期望职位"
                ></Input>
              </FormItem>

              <!-- 教育经历 -->
              <FormItem label="教育经历">
                <div v-for="(school, index) in formValidate.schools" :key="index" style="margin-bottom: 15px; padding: 15px; border: 1px solid #dcdee2; border-radius: 6px; background: #f8f8f9;">
                  <Row :gutter="16">
                    <i-col span="12">
                      <FormItem label="学校名称" :label-width="80">
                        <Input v-model="school.school" placeholder="请输入学校名称"></Input>
                      </FormItem>
                    </i-col>
                    <i-col span="12">
                      <FormItem label="专业名称" :label-width="80">
                        <Input v-model="school.major" placeholder="请输入专业名称"></Input>
                      </FormItem>
                    </i-col>
                  </Row>
                  <Row :gutter="16">
                    <i-col span="8">
                      <FormItem label="学历" :label-width="80">
                        <Input v-model="school.edu" placeholder="请输入学历"></Input>
                      </FormItem>
                    </i-col>
                    <i-col span="8">
                      <FormItem label="开始时间" :label-width="80">
                        <Input v-model="school.stime" placeholder="如：2010-09"></Input>
                      </FormItem>
                    </i-col>
                    <i-col span="8">
                      <FormItem label="结束时间" :label-width="80">
                        <Input v-model="school.etime" placeholder="如：2014-06"></Input>
                      </FormItem>
                    </i-col>
                  </Row>
                  <Button type="error" size="small" @click="removeSchool(index)" style="margin-top: 5px;">删除此教育经历</Button>
                </div>
                <Button type="dashed" long @click="addSchool" icon="md-add">添加教育经历</Button>
              </FormItem>

              <!-- 工作经历 -->
              <FormItem label="工作经历">
                <div v-for="(work, index) in formValidate.workExperiences" :key="index" style="margin-bottom: 15px; padding: 15px; border: 1px solid #dcdee2; border-radius: 6px; background: #f8f8f9;">
                  <Row :gutter="16">
                    <i-col span="12">
                      <FormItem label="公司名称" :label-width="80">
                        <Input v-model="work.company" placeholder="请输入公司名称"></Input>
                      </FormItem>
                    </i-col>
                    <i-col span="12">
                      <FormItem label="职位名称" :label-width="80">
                        <Input v-model="work.position" placeholder="请输入职位名称"></Input>
                      </FormItem>
                    </i-col>
                  </Row>
                  <Row :gutter="16">
                    <i-col span="12">
                      <FormItem label="开始时间" :label-width="80">
                        <Input v-model="work.stime" placeholder="如：2014-07"></Input>
                      </FormItem>
                    </i-col>
                    <i-col span="12">
                      <FormItem label="结束时间" :label-width="80">
                        <Input v-model="work.etime" placeholder="如：2018-06 或 至今"></Input>
                      </FormItem>
                    </i-col>
                  </Row>
                  <Row>
                    <i-col span="24">
                      <FormItem label="工作内容" :label-width="80">
                        <Input type="textarea" :rows="3" v-model="work.description" placeholder="请输入工作内容描述"></Input>
                      </FormItem>
                    </i-col>
                  </Row>
                  <Button type="error" size="small" @click="removeWork(index)" style="margin-top: 5px;">删除此工作经历</Button>
                </div>
                <Button type="dashed" long @click="addWork" icon="md-add">添加工作经历</Button>
              </FormItem>

              <FormItem label="技能特长" prop="skills">
                <Input
                  type="textarea"
                  :rows="3"
                  v-model="formValidate.skills"
                  placeholder="请输入技能特长"
                ></Input>
              </FormItem>

              <FormItem label="自我评价" prop="evaluation">
                <Input
                  type="textarea"
                  :rows="3"
                  v-model="formValidate.evaluation"
                  placeholder="请输入自我评价"
                ></Input>
              </FormItem>

              <!-- 简历图片上传 -->
              <FormItem label="简历图片">
                <Upload
                  :action="uploadAction"
                  :headers="uploadHeaders"
                  :on-success="handleUploadSuccess"
                  :on-error="handleUploadError"
                  :format="['jpg','jpeg','png']"
                  :max-size="2048"
                  :on-format-error="handleFormatError"
                  :on-exceeded-size="handleMaxSize"
                  :show-upload-list="false"
                  accept="image/*">
                  <Button icon="ios-cloud-upload-outline">上传简历图片</Button>
                </Upload>
                <div v-if="formValidate.perpic" style="margin-top: 10px;">
                  <el-image
                    style="width: 150px; height: 200px; border: 1px solid #dcdee2; border-radius: 4px;"
                    :src="formValidate.perpic"
                    :preview-src-list="[formValidate.perpic]"
                    fit="contain">
                  </el-image>
                  <div style="margin-top: 5px;">
                    <Button type="error" size="small" @click="formValidate.perpic = ''">删除图片</Button>
                  </div>
                </div>
              </FormItem>

              <FormItem
                label="备注"
                prop="Remark"
              >
                <Input
                  type="textarea"
                  v-model="formValidate.Remark"
                  placeholder="请输入"
                ></Input>
              </FormItem>
              <FormItem>
                <Button
                  type="primary"
                  @click="handleSubmit('formValidate')"
                >提交
                </Button>
                <Button
                  @click="handleReset('formValidate')"
                  style="margin-left: 8px"
                >重置
                </Button>
              </FormItem>

            </Form>
          </Modal>
        </Card>
      </i-col>
    </Row>
    <Spin size="large" fix v-if="spinShow"></Spin>
    <el-drawer
      title="个人信息"
      :visible.sync="msgmodal"
      direction="ltr"
      size="35%">
      <el-divider></el-divider>

      <el-form ref="form" :model="formValidate_per" label-width="110px">

        <el-form-item label="姓名：">
          {{ formValidate_per.Pname }}
        </el-form-item>
        <el-form-item label="性别：">
          {{ formValidate_per.Psex_CN }}
        </el-form-item>
        <el-form-item label="年龄：">
          {{ formValidate_per.age }}
        </el-form-item>
        <el-form-item label="身份证：">
          {{ formValidate_per.Pidcard }}
        </el-form-item>
<!--        <el-form-item label="户籍地址：">-->
<!--          {{ formValidate_per.Paddress }}-->
<!--        </el-form-item>-->
        <el-form-item label="现居住区域：">
          {{ formValidate_per.Pnowaddress }}
        </el-form-item>
        <el-form-item label="联系电话：">
          {{ formValidate_per.Pphone }}
        </el-form-item>
<!--        <el-form-item label="婚姻状况：">-->
<!--          {{ formValidate_per.Pmarriage_CN }}-->
<!--        </el-form-item>-->
<!--        <el-form-item label="民族：">-->
<!--          {{ formValidate_per.Pnation_CN }}-->
<!--        </el-form-item>-->

        <el-divider content-position="left">求职意向</el-divider>

        <el-form-item label="期望职位：">
          {{ formValidate_per.Pjob_CN }}
        </el-form-item>
        <el-form-item label="期望薪酬：">
          {{ formValidate_per.Psalary_CN }}
        </el-form-item>

        <el-divider content-position="left">简历信息</el-divider>

        <el-form-item label="最高学历：">
          {{ formValidate_per.Peducation_CN }}
        </el-form-item>
        <el-form-item label="工作年限：">
          {{ formValidate_per.Pexperience_CN }}
        </el-form-item>

        <el-form-item label="工作经历：" v-if="formValidate_per.workExperience">
          <div style="white-space: pre-wrap;">{{ formValidate_per.workExperience }}</div>
        </el-form-item>

        <el-form-item label="技能特长：" v-if="formValidate_per.skills">
          <div style="white-space: pre-wrap;">{{ formValidate_per.skills }}</div>
        </el-form-item>

        <el-form-item label="自我评价：" v-if="formValidate_per.evaluation">
          <div style="white-space: pre-wrap;">{{ formValidate_per.evaluation }}</div>
        </el-form-item>

        <el-form-item label="教育经历：" v-if="formValidate_per.schools && formValidate_per.schools.length > 0">
          <div v-for="(school, index) in formValidate_per.schools" :key="index" style="margin-bottom: 15px; padding: 10px; background: #f7f7f7; border-radius: 4px;">
            <div><strong>学校：</strong>{{ school.school }}</div>
            <div><strong>专业：</strong>{{ school.major }}</div>
            <div><strong>学历：</strong>{{ school.edu }}</div>
            <div><strong>就读时间：</strong>{{ school.stime }} - {{ school.etime }}</div>
          </div>
        </el-form-item>
         <el-form-item label="工作经历：" v-if="formValidate_per.works && formValidate_per.works.length > 0">
          <div v-for="(work, index) in formValidate_per.works" :key="index" style="margin-bottom: 15px; padding: 10px; background: #f7f7f7; border-radius: 4px;">
            <div><strong>单位：</strong>{{ work.company }}</div>
            <div><strong>职位：</strong>{{ work.jobname }}</div>
            <div><strong>内容：</strong>{{ work.info }}</div>
            <div><strong>工作时间：</strong>{{ work.stime }} - {{ work.etime }}</div>
          </div>
        </el-form-item>

        <el-form-item label="简历图片：" v-if="formValidate_per.perpic">
          <el-image
            style="width: 100px; height: 100px"
            :src="formValidate_per.perpic"
            :preview-src-list="formValidate_per.perpiclist">
          </el-image>
        </el-form-item>

        <el-form-item label="备注：" v-if="formValidate_per.Remark">
          <div style="white-space: pre-wrap;">{{ formValidate_per.Remark }}</div>
        </el-form-item>
      </el-form>
    </el-drawer>

    <!-- 教育经历展示Modal -->
    <Modal v-model="schoolModalVisible" title="教育经历" width="700" :mask-closable="true" class-name="experience-modal">
      <div style="max-height: 500px; overflow-y: auto;">
        <div v-for="(item, index) in schoolModalData" :key="index" class="experience-item">
          <div class="experience-header">
            <Icon type="ios-school" style="margin-right: 8px;"/>
            教育经历 {{ index + 1 }}
          </div>
          <div class="experience-content">
            <Row :gutter="16">
              <i-col span="12">
                <div class="info-item">
                  <span class="label">就读时间：</span>
                  <span class="value">{{ item.stime }} - {{ item.etime }}</span>
                </div>
              </i-col>
              <i-col span="12">
                <div class="info-item">
                  <span class="label">学历：</span>
                  <span class="value">{{ item.edu }}</span>
                </div>
              </i-col>
            </Row>
            <Row :gutter="16">
              <i-col span="24">
                <div class="info-item">
                  <span class="label">学校名称：</span>
                  <span class="value">{{ item.school }}</span>
                </div>
              </i-col>
            </Row>
            <Row :gutter="16">
              <i-col span="24">
                <div class="info-item">
                  <span class="label">专业名称：</span>
                  <span class="value">{{ item.major }}</span>
                </div>
              </i-col>
            </Row>
          </div>
        </div>
        <div v-if="schoolModalData.length === 0" style="text-align: center; padding: 40px; color: #999;">
          暂无教育经历信息
        </div>
      </div>
      <div slot="footer">
        <Button @click="schoolModalVisible = false">关闭</Button>
      </div>
    </Modal>

    <!-- 工作经历展示Modal -->
    <Modal v-model="workModalVisible" title="工作经历" width="750" :mask-closable="true" class-name="experience-modal">
      <div style="max-height: 500px; overflow-y: auto;">
        <div v-for="(item, index) in workModalData" :key="index" class="experience-item">
          <div class="experience-header work-header">
            <Icon type="ios-briefcase" style="margin-right: 8px;"/>
            工作经历 {{ index + 1 }}
          </div>
          <div class="experience-content">
            <Row :gutter="16">
              <i-col span="12">
                <div class="info-item">
                  <span class="label">公司名称：</span>
                  <span class="value">{{ item.company }}</span>
                </div>
              </i-col>
              <i-col span="12">
                <div class="info-item">
                  <span class="label">职位：</span>
                  <span class="value">{{ item.jobname }}</span>
                </div>
              </i-col>
            </Row>
            <Row :gutter="16">
              <i-col span="24">
                <div class="info-item">
                  <span class="label">工作时间：</span>
                  <span class="value">{{ item.stime }} - {{ item.etime }}</span>
                </div>
              </i-col>
            </Row>
            <Row :gutter="16">
              <i-col span="24">
                <div class="info-item">
                  <span class="label">工作内容：</span>
                  <span class="value" style="white-space: pre-wrap;">{{ item.info }}</span>
                </div>
              </i-col>
            </Row>
          </div>
        </div>
        <div v-if="workModalData.length === 0" style="text-align: center; padding: 40px; color: #999;">
          暂无工作经历信息
        </div>
      </div>
      <div slot="footer">
        <Button @click="workModalVisible = false">关闭</Button>
      </div>
    </Modal>
  </div>
</template>

<script>

  import {
    getPersonlist,
    operationPerson,
    getPersonStatistics
  } from '@/api/person/person.js'

  import { getsysparameterList } from '@/api/system/sys_parameter'
  import { mapState } from 'vuex'
  import excel from '@/libs/excel'

  // import {Notification} from 'element-ui';

  let moment = require('moment')
  export default {

    data () {
      return {
        tableLoading: false,
        showProgress: false,
        uploadLoading: false,
        showRemoveFile: false,
        progressPercent: 0,
        inprogress: 0,
        showre: false,
        showretxt: '',
        file: null,
        spinShow: false,
        fullscreenLoading: false,
        PsexList: [],
        PmarriageList: [],
        PnationList: [],
        PeducationList: [],
        PexperienceList: [],
        PsalaryList: [],
        formValidate: {},
        searchVal: '',
        tableData: [],
        modalMap: {
          modalVisible: false,
          modalTitle: '新建'
        },
        tableSelectIdList: [],
        editModalData: '',
        pageNum: 1, // 当前页码
        pageTotal: 0, // 数据总数
        pageSize: 15, // 每页条数
        msgmodal: false,
        formValidate_per: {},
        schoolModalVisible: false,
        schoolModalData: [],
        workModalVisible: false,
        workModalData: [],
        uploadAction: '',
        uploadHeaders: {},
        showAdvancedSearch: false,
        advancedSearchForm: {
          Pname: '',
          Psex: '',
          Pphone: '',
          Peducation: '',
          Pexperience: '',
          Psalary: '',
          Pnowaddress: '',
          Pjob: '',
          Pstate: ''
        },
        statistics: {
          totalUsers: 0,
          registeredUsers: 0,
          resumeCount: 0,
          intentionCount: 0
        },
        ruleValidate: {
          // admin_user: [{ required: true, message: "请选择管理用户", trigger: "change"}],
          Pname: [
            {
              required: true,
              message: '姓名不能为空',
              trigger: 'blur'
            }
          ],
          Pidcard: [
            {
              required: true,
              message: '身份证不能为空',
              trigger: 'blur'
            }
          ],
          Psex: [
            {
              required: true,
              message: '请选择',
              trigger: 'change'
            }
          ],
          // Pmarriage: [
          //   {
          //     required: true,
          //     message: "请选择",
          //     trigger: "change"
          //   }
          // ],
          Pnation: [
            {
              required: true,
              message: '请选择',
              trigger: 'change'
            }
          ],
          Peducation: [
            {
              required: true,
              message: '请选择',
              trigger: 'change'
            }
          ],
          Pexperience: [
            {
              required: true,
              message: '请选择',
              trigger: 'change'
            }
          ],
          Psalary: [
            {
              required: true,
              message: '请选择',
              trigger: 'change'
            }
          ]

        },
        columns: [
          {
            type: 'selection',
            key: 'id',
            width: 60,
            fixed: 'left',
            align: 'center'
          },
          {
            title: '姓名',
            key: 'Pname',
            width: 100,
            tooltip: 'true',
            align: 'center',
            fixed: 'left',
            sortable: true,
            render: (h, params) => {
              return h('a', {
                  on: {
                    click: () => {
                      this.perinfo_show(params.row)
                    }
                  }
                }, params.row.Pname
              )
            }
          },
          {
            title: '性别',
            key: 'Psex_CN',
            tooltip: 'true',
            width: 80,
            align: 'center',
            sortable: true
          },
           {
            title: '年龄',
            key: 'age',
            tooltip: 'true',
            width: 80,
            align: 'center',
            sortable: true
          },
          {
            title: '身份证',
            key: 'Pidcard',
            tooltip: 'true',
            width: 180,
            align: 'center',
            sortable: true
          },

          {
            title: '联系电话',
            key: 'Pphone',
            tooltip: 'true',
            width: 150,
            align: 'center',
            sortable: true
          },
          // {
          //   title: "婚姻状况",
          //   key: "Pmarriage_CN",
          //   tooltip:"true",
          //   width: 110,
          //   align: "center",
          //   sortable: true
          // },
          // {
          //   title: "民族",
          //   key: "Pnation_CN",
          //   tooltip:"true",
          //   width: 100,
          //   align: "center",
          //   sortable: true
          // },
          {
            title: '求职意向',
                        align: 'center',
                        children: [{
            title: '现居住区域',
            key: 'Pnowaddress',
            tooltip: 'true',
            width: 200,
            align: 'center',
            sortable: true
          },
           {
            title: '期望职位',
            key: 'Pjob_CN',
            tooltip: 'true',
            width: 150,
            align: 'center',
            sortable: true
          },
          {
            title: '期望薪资',
            key: 'Psalary_CN',
            width: 150,
            tooltip: 'true',
            align: 'center',
            sortable: true
          }]
          },

          {
            title: '简历信息',
            align: 'center',
            children: [{
            title: '最高学历',
            key: 'Peducation_CN',
            tooltip: 'true',
            width: 150,
            align: 'center',
            sortable: true
          },
          {
            title: '工作经验',
            key: 'Pexperience_CN',
            tooltip: 'true',
            width: 150,
            align: 'center',
            sortable: true
          }, {
            title: '教育经历',
            key: 'Pexperience_CN',
            tooltip: 'true',
            width: 150,
            align: 'center',
            sortable: true,
                render: (h, params) => {
              if (params.row.schools.length>0) {
                return h('a', {
                  on: {
                    click: () => {
                      this.schoolshow(params.row.schools)
                    }
                  }
                }, '查看:（' + params.row.schools.length + '）'
              )
              } else {
                return h('div', {
                }, '无'
              )
              }
            }
          }, {
            title: '工作经历',
            key: 'workExperiences',
            tooltip: 'true',
            width: 150,
            align: 'center',
            sortable: true,
            render: (h, params) => {
              if (params.row.works && params.row.works.length>0) {
                return h('a', {
                  on: {
                    click: () => {
                      this.workshow(params.row.works)
                    }
                  }
                }, '查看:（' + params.row.works.length + '）'
              )
              } else {
                return h('div', {
                }, '无'
              )
              }
            }
          }, {
            title: '技能特长',
            key: 'skills',
            tooltip: 'true',
            width: 150,
            align: 'center',
            sortable: true
          }, {
            title: '自我评价',
            key: 'evaluation',
            tooltip: 'true',
            width: 150,
            align: 'center',
            sortable: true
          }]
          },

          {
            title: '来源',
            key: 'Ptype_CN',
            width: 100,
            align: 'center',
            sortable: true
          },
          {
            title: '注册时间',
            key: 'Addtime',
            width: 120,
            align: 'center',
            tooltip: 'true',
            sortable: true
          },

          {
            title: '状态',
            key: 'Pstate_CN',
            width: 100,
            fixed: 'right',
            align: 'center',
            sortable: true
          },

          {
            title: '操作',
            key: 'handle',
            fixed: 'right',
            width: 150,
            align: 'center',
            render: (h, params) => {
              return h('div', [
                  h(
                    'Button',
                    {
                      props: {
                        type: 'primary',
                        size: 'small'
                      },
                      style: {
                        marginRight: '5px'
                      },
                      on: {
                        click: () => {
                          this.editModal(params.row, 'put', '修改')
                        }
                      }
                    },
                    '编辑'
                  ),

                h(
                  'Button',
                  {
                    props: {
                      type: 'error',
                      size: 'small'
                    },
                    style: {
                      marginRight: '5px'
                    },
                    on: {
                      click: () => {
                        this.delData(params)
                      }
                    }
                  },
                  '删除'
                )
                ])
              }

          }
        ]
      }
    },
    computed: {
      ...mapState({
        rules: state => state.user.rules
      }),
      yesterdayDate () {
        const yesterday = new Date()
        yesterday.setDate(yesterday.getDate() - 1)
        const year = yesterday.getFullYear()
        const month = String(yesterday.getMonth() + 1).padStart(2, '0')
        const day = String(yesterday.getDate()).padStart(2, '0')
        return `${year}-${month}-${day}`
      },
      todayDate () {
        const today = new Date()
        const year = today.getFullYear()
        const month = String(today.getMonth() + 1).padStart(2, '0')
        const day = String(today.getDate()).padStart(2, '0')
        return `${year}-${month}-${day}`
      }
    },
    methods: {

schoolshow (data) {
                this.schoolModalData = data
                this.schoolModalVisible = true
            },
      workshow (data) {
        this.workModalData = data
        this.workModalVisible = true
      },
      addSchool () {
        if (!this.formValidate.schools) {
          this.$set(this.formValidate, 'schools', [])
        }
        this.formValidate.schools.push({
          school: '',
          major: '',
          edu: '',
          stime: '',
          etime: ''
        })
      },
      removeSchool (index) {
        this.formValidate.schools.splice(index, 1)
      },
      addWork () {
        if (!this.formValidate.workExperiences) {
          this.$set(this.formValidate, 'workExperiences', [])
        }
        this.formValidate.workExperiences.push({
          company: '',
          position: '',
          stime: '',
          etime: '',
          description: ''
        })
      },
      removeWork (index) {
        this.formValidate.workExperiences.splice(index, 1)
      },
      handleUploadSuccess (response, file, fileList) {
        if (response.code === 0) {
          this.$set(this.formValidate, 'perpic', response.data.url)
          this.$Message.success('图片上传成功')
        } else {
          this.$Message.error('图片上传失败：' + response.msg)
        }
      },
      handleUploadError (error, file, fileList) {
        this.$Message.error('图片上传失败')
      },
      handleFormatError (file) {
        this.$Message.warning('文件格式不正确，请上传jpg或png格式的图片')
      },
      handleMaxSize (file) {
        this.$Message.warning('文件大小超过2MB，请压缩后上传')
      },
      getStatistics () {
        getPersonStatistics().then(res => {
          if (res.data.code === 0) {
            this.statistics = res.data.data
          } else {
            this.$Message.error(`获取统计数据失败：${res.data.msg}`)
          }
        }).catch(err => {
          console.error('获取统计数据出错：', err)
        })
      },
      advancedSearch () {
        // 构建高级搜索参数
        let searchParams = []
        if (this.advancedSearchForm.Pname) {
          searchParams.push(`Pname:${this.advancedSearchForm.Pname}`)
        }
        if (this.advancedSearchForm.Psex) {
          searchParams.push(`Psex:${this.advancedSearchForm.Psex}`)
        }
        if (this.advancedSearchForm.Pphone) {
          searchParams.push(`Pphone:${this.advancedSearchForm.Pphone}`)
        }
        if (this.advancedSearchForm.Peducation) {
          searchParams.push(`Peducation:${this.advancedSearchForm.Peducation}`)
        }
        if (this.advancedSearchForm.Pexperience) {
          searchParams.push(`Pexperience:${this.advancedSearchForm.Pexperience}`)
        }
        if (this.advancedSearchForm.Psalary) {
          searchParams.push(`Psalary:${this.advancedSearchForm.Psalary}`)
        }
        if (this.advancedSearchForm.Pnowaddress) {
          searchParams.push(`Pnowaddress:${this.advancedSearchForm.Pnowaddress}`)
        }
        if (this.advancedSearchForm.Pjob) {
          searchParams.push(`Pjob:${this.advancedSearchForm.Pjob}`)
        }
        if (this.advancedSearchForm.Pstate) {
          searchParams.push(`Pstate:${this.advancedSearchForm.Pstate}`)
        }

        if (searchParams.length > 0) {
          this.searchVal = searchParams.join('|')
          this.pageNum = 1
          this.getPersonlist(this.searchVal)
        } else {
          this.$Message.warning('请至少选择一个搜索条件')
        }
      },
      resetAdvancedSearch () {
        this.advancedSearchForm = {
          Pname: '',
          Psex: '',
          Pphone: '',
          Peducation: '',
          Pexperience: '',
          Psalary: '',
          Pnowaddress: '',
          Pjob: '',
          Pstate: ''
        }
        this.searchVal = ''
        this.pageNum = 1
        this.getPersonlist()
      },
      perinfo_show (val) {
        this.msgmodal = true
        this.formValidate_per = val
      },

      getPersonlist (key, value) {
        this.spinShow = true
        getPersonlist(this.pageNum, this.pageSize, key, value).then(res => {
          if (res.data.code === 0) {
            this.pageTotal = res.data.count
            this.tableData = res.data.data
          } else {
            this.$Message.error(`${res.data.msg}`)
          }
          this.spinShow = false
        })
      },

      handlerimport () {
        if (this.tableDatatmp.length > 0) {
          this.uploadLoading = true
          this.sendMessage({ 'data_list': this.tableDatatmp, 'filename': this.file.name })
          this.uploadLoading = false
        }
      },
      // table 选中的ID
      handleSelectChange (val) {
        let SelectIdList = []
        val.forEach(item => {
          SelectIdList.push(item.Id)
        })

        this.tableSelectIdList = SelectIdList
      },

      closeModal () {
        this.dialog.show = false
      },
      getSYSparameterList () {
        getsysparameterList('person_info', 'Psex').then(res => {
          if (res.data.code === 0) {
            this.PsexList = res.data.data
          } else {
            this.$Message.error(`${res.data.msg}`)
          }
        })
        getsysparameterList('person_info', 'Pmarriage').then(res => {
          if (res.data.code === 0) {
            this.PmarriageList = res.data.data
          } else {
            this.$Message.error(`${res.data.msg}`)
          }
        })
        getsysparameterList('person_info', 'Pnation').then(res => {
          if (res.data.code === 0) {
            this.PnationList = res.data.data
          } else {
            this.$Message.error(`${res.data.msg}`)
          }
        })
        getsysparameterList('person_info', 'Peducation').then(res => {
          if (res.data.code === 0) {
            this.PeducationList = res.data.data
          } else {
            this.$Message.error(`${res.data.msg}`)
          }
        })
        getsysparameterList('person_info', 'Pexperience').then(res => {
          if (res.data.code === 0) {
            this.PexperienceList = res.data.data
          } else {
            this.$Message.error(`${res.data.msg}`)
          }
        })
        getsysparameterList('person_info', 'Psalary').then(res => {
          if (res.data.code === 0) {
            this.PsalaryList = res.data.data
          } else {
            this.$Message.error(`${res.data.msg}`)
          }
        })
        getsysparameterList('person_info', 'Pnation').then(res => {
          if (res.data.code === 0) {
            this.PnationList = res.data.data
          } else {
            this.$Message.error(`${res.data.msg}`)
          }
        })
      },

      editModal (paramsRow, meth, mtitle) {
        this.modalMap.modalVisible = true
        this.modalMap.modalTitle = mtitle
        this.editModalData = meth
        // this.getSYSparameterList();
        if (paramsRow && paramsRow.Id) {
          Object.keys(paramsRow).forEach(key => {
            if (paramsRow[key] === null) {
              paramsRow[key] = ''
            }
          })
          console.log(paramsRow)
          this.formValidate = {
            Id: paramsRow.Id,
            Pname: paramsRow.Pname,
            Psex: paramsRow.Psex.toString(),
            Pidcard: paramsRow.Pidcard,
            Paddress: paramsRow.Paddress,
            Pphone: paramsRow.Pphone,
            Pmarriage: paramsRow.Pmarriage.toString(),
            Pnation: paramsRow.Pnation.toString(),
            Peducation: paramsRow.Peducation.toString(),
            Pexperience: paramsRow.Pexperience.toString(),
            Psalary: paramsRow.Psalary.toString(),
            Remark: paramsRow.Remark,
            Pnowaddress: paramsRow.Pnowaddress,
            Pjob: paramsRow.Pjob || '',
            skills: paramsRow.skills || '',
            evaluation: paramsRow.evaluation || '',
            schools: paramsRow.schools || [],
            workExperiences: paramsRow.workExperiences || [],
            perpic: paramsRow.perpic || ''
          }
        } else {
          this.formValidate = {
            Id: 0,
            Pname: '',
            Psex: '',
            Pidcard: '',
            Paddress: '',
            Pphone: '',
            Pmarriage: '',
            Pnation: '',
            Peducation: '',
            Pexperience: '',
            Psalary: '',
            Remark: '',
            Pnowaddress: '',
            Pjob: '',
            skills: '',
            evaluation: '',
            schools: [],
            workExperiences: [],
            perpic: ''
          }
        }
      },
      handleSubmit (value) {
        this.$refs[value].validate((valid) => {
          if (valid) {
            setTimeout(() => {
              operationPerson(this.formValidate, this.editModalData).then(res => {
                if (res.data.code === 0) {
                  this.$Message.success(`${res.data.msg}`)

                  if (this.searchVal) {
                    this.getPersonlist(this.searchVal)
                  } else {
                    this.getPersonlist()
                  }
                  this.modalMap.modalVisible = false
                } else {
                  this.$Message.error(`${res.data.msg}`)
                }
              })
            }, 1000)
            // this.$Message.success('Success!');
          } else {
            this.$Message.error('缺少必要参数')
          }
        })
      },
connectWebSocket () {
        // 在这里传递参数
       this.ws = new WebSocket('wss://www.tcdpgaoxin.cn/m_ws/per/importws/')
        // this.ws = new WebSocket('ws://localhost:9000/m_ws/per/importws/');
        this.ws.onmessage = (event) => {
          console.log('收到消息：', event.data)
          try {
          let json = JSON.parse(event.data)
          if (json.code == 1) {
            this.inprogress = json.percent
          } else if (json.code == 0) {
            this.$Message.success(`${json.msg}`)
            this.showre = true
            this.inprogress = json.percent
            this.showretxt = json.msg
            this.uploadLoading = false
            if (this.ws) {
              this.ws.close(1000, '正常关闭连接')
              this.ws = null
            }
            this.getjoblist(this.searchVal)
          } else {
            this.$Message.error(`${json.msg}`)
            if (this.ws) {
              this.ws.close(1000, '正常关闭连接')
              this.ws = null
            }
          }
          } catch (e) {

          }
        }

        this.ws.onclose = () => {
          console.log('WebSocket closed')
          this.ws = null
        }
      },
      sendMessage (message) {
        if (this.ws.readyState === WebSocket.OPEN) {
          this.ws.send(JSON.stringify(message))
        } else {
          console.log('上传通道未打开')
        }
      },

      handleReset (name) {
        this.$refs[name].resetFields()
      },
initUpload () {
        this.file = null
        this.showre = false
        this.showProgress = false
        this.loadingProgress = 0
        this.progressPercent = 0
        this.tableDatatmp = []
        this.tableTitle = []
        this.connectWebSocket()
      },
handleUploadFile () {
        this.initUpload()
      },
      readFile (file) {
      const reader = new FileReader()
      reader.readAsArrayBuffer(file)
      reader.onloadstart = e => {
        this.uploadLoading = true
        this.tableLoading = true
        this.showProgress = true
      }
      reader.onprogress = e => {
        this.progressPercent = Math.round(e.loaded / e.total * 100)
      }
      reader.onerror = e => {
        this.$Message.error('文件读取出错')
      }
      reader.onload = e => {
        this.$Message.info('文件读取成功')
        this.progressPercent = 100
        const data = e.target.result
        const { header, results } = excel.read(data, 'array')
        const tableTitle = header.map(item => {
          return { title: item, key: item }
        })
        this.tableDatatmp = results
        this.tableTitle = tableTitle
        this.uploadLoading = false
        this.tableLoading = false
        this.showRemoveFile = true
        // this.showProgress = false
      }
    },
            handleRemove () {
        this.showProgress = false
        this.showre = false
        this.initUpload()
        this.$Message.info('上传的文件已删除！')
      },
handleBeforeUpload (file) {
        const fileExt = file.name.split('.').pop().toLocaleLowerCase()
        if (fileExt === 'xlsx' || fileExt === 'xls') {
          this.readFile(file)
          this.uploadLoading = true
          this.tableLoading = true
          this.showProgress = true
          this.file = file
        } else {
          this.$Notice.warning({
            title: '文件类型错误',
            desc: '文件：' + file.name + '不是EXCEL文件，请选择后缀为.xlsx或者.xls的EXCEL文件。'
          })
        }
        return false
      },

      handlerDelete () {
        // console.log(this.tableSelectIdList.length)
        if (this.tableSelectIdList.length > 0) {
          if (confirm(`确定要批量删除选中求职者嘛？ `)) {
            operationPerson({ 'id_list': this.tableSelectIdList }, 'delete').then(
              res => {
                if (res.data.code === 0) {
                  this.$Message.success(`${res.data.msg}`)
                  this.getPersonlist(this.searchVal)
                } else {
                  this.$Message.error(`${res.data.msg}`)
                }
              })
          }
        } else {
          this.$Message.info(`你总要选中点什么吧`)
        }
      },
      // 删除
      delData (params) {
        if (confirm(`确定要删除 ${params.row.Pname}`)) {
          // console.log(params.row.id)
          operationPerson(
            {
              'Id': params.row.Id,
              'uid': params.row.Puid
            },
            'delete'
          ).then(res => {
            if (res.data.code === 0) {
              this.$Message.success(`${res.data.msg}`)
              this.tableData.splice(params.index, 1)
            } else {
              this.$Message.error(`${res.data.msg}`)
            }
          })
        }
      },

      // 点击节点
      // 翻页
      changePage (value) {
        this.pageNum = value
        if (this.searchVal) {
          this.getPersonlist(this.searchVal)
        } else {
          this.getPersonlist()
        }
      },
      // 切换分页
      handlePageSize (value) {
        this.pageSize = value
        this.pageNum = 1
        if (this.searchVal) {
          this.getPersonlist(this.searchVal)
        } else {
          this.getPersonlist()
        }
      },
      searchinput () {
        if (this.searchVal) {
          this.getPersonlist(this.searchVal)
        } else {
          this.getPersonlist()
        }
      }
    },

    watch: {
      searchVal (val) {
        this.searchVal = val
        // this.getServerList(this.searchVal)
      }
    },
    mounted () {
      this.getSYSparameterList()
      this.getPersonlist()
      this.getStatistics()

      // 配置图片上传
      this.uploadAction = '/api/v1/upload/image' // 根据实际后端接口调整
      this.uploadHeaders = {
        'Authorization': localStorage.getItem('token') || ''
      }
    }
  }

</script>

<style lang="css" >
.el-drawer {
  overflow: auto;
}
</style>

<style lang="less" scoped>

  .statistics-item {
    display: flex;
    align-items: center;
    padding: 10px;

    .statistics-content {
      margin-left: 15px;
      flex: 1;

      .statistics-label {
        font-size: 14px;
        color: #808695;
        margin-bottom: 5px;
      }

      .statistics-value {
        font-size: 24px;
        font-weight: bold;
        color: #17233d;
        margin-bottom: 8px;
      }

      .statistics-note {
        font-size: 12px;
        color: #999;
        line-height: 1.6;

        .note-source {
          margin-bottom: 2px;
        }

        .note-date {
          color: #2d8cf0;
          font-weight: 500;
        }
      }
    }
  }

  // 统一的经历展示样式
  .experience-item {
    margin-bottom: 20px;
    border: 1px solid #e8eaec;
    border-radius: 8px;
    overflow: hidden;
    background: #fff;
    transition: box-shadow 0.3s ease;

    &:hover {
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    }

    &:last-child {
      margin-bottom: 0;
    }
  }

  .experience-header {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: #fff;
    padding: 12px 16px;
    font-weight: 600;
    font-size: 15px;
    display: flex;
    align-items: center;

    &.work-header {
      background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
    }
  }

  .experience-content {
    padding: 16px;
  }

  .info-item {
    margin-bottom: 12px;
    display: flex;
    align-items: center;

    &:last-child {
      margin-bottom: 0;
    }

    .label {
      font-weight: 500;
      color: #515a6e;
      min-width: 90px;
      margin-right: 8px;
      flex-shrink: 0;
    }

    .value {
      color: #2d2d2d;
      background: #f7f7f7;
      padding: 6px 10px;
      border-radius: 4px;
      border: 1px solid #dcdee2;
      flex: 1;
      min-height: 24px;
      display: flex;
      align-items: center;
    }
  }

  .search-con {
    padding: 10px 0;

    .search {
      &-col {
        display: inline-block;
        width: 200px;
      }

      &-input {
        display: inline-block;
        width: 200px;
        margin-left: 2px;
      }

      &-btn {
        margin-left: 2px;
      }
    }
  }
</style>
